import { useIntl } from 'react-intl';
import { Stack } from '@rossum/ui/material';

export const ConditionCell = ({ value }: { value: boolean | undefined }) => {
  const intl = useIntl();

  if (value === undefined) {
    return null;
  }

  const conditionMatched = value === true;

  return (
    <Stack
      direction="row"
      spacing={1}
      width="100%"
      alignItems="center"
      height="100%"
    >
      {conditionMatched
        ? intl.formatMessage({ id: 'features.formulas.matched' })
        : null}
    </Stack>
  );
};
